import { AfterViewInit, Component, inject, ViewChild } from '@angular/core';
import { MONTH_ENUM_BY_INDEX } from 'src/app/shared/constants-and-enums/months';
import { MonthAndYearPickerComponent } from 'src/app/shared/components/month-and-year-picker/month-and-year-picker.component';
import { SmartAssistantImportService } from '../smart-assistant-import.service';

@Component({
    standalone: false,
    selector: 'app-smart-assistant-urban-sports-club-date-step',
    templateUrl: './smart-assistant-urban-sports-club-date-step.component.html'
})
export class SmartAssistantUrbanSportsClubDateStepComponent implements AfterViewInit {
    @ViewChild(MonthAndYearPickerComponent) picker: MonthAndYearPickerComponent;

    private readonly service = inject(SmartAssistantImportService);

    ngAfterViewInit(): void {
        const existing = this.service.urbanSportsClubTargetMonth();
        if (existing) {
            const month = MONTH_ENUM_BY_INDEX.indexOf(existing.month);
            this.picker.dateForm.patchValue({ month, year: existing.year }, { emitEvent: false });
        } else {
            this.updateTargetMonth(this.picker.dateForm.value.month, this.picker.dateForm.value.year);
        }
    }

    onDateChanged(value: { month?: number; year?: number }): void {
        this.updateTargetMonth(Number(value.month), Number(value.year));
    }

    private updateTargetMonth(zeroBasedMonth: number, year: number): void {
        this.service.updateUrbanSportsClubTargetMonth(year, MONTH_ENUM_BY_INDEX[zeroBasedMonth]);
    }
}
